module.exports = __webpack_public_path__ + "img/itc_map.6ccc4f80.png";